export default {
  clientId: 'ApplicationSubmissionUI',
  replica: {
    cloudinaryName: 'carfinance247-secure',
    auth: {
      accessType: 2,
      clientId: 'Carfinance.Submission.Application.UI',
      password: 'indigohome67',
      userName: 'Carfinance.Submission.Application.UI'
    }
  },
  production: {
    cloudinaryName: 'carfinance247-secure',
    auth: {
      accessType: 2,
      clientId: 'Carfinance.Submission.Application.UI',
      password: 'Xy7qxEcYjDBS5mc2',
      userName: 'Carfinance.Submission.Application.UI'
    }
  }
}
